import { Stack, Typography } from '@fox/atoms';
import { useComponentClassContext } from '../component-class-context';
import { useComponentStyleContext } from '../component-style-context';
import { IRenderSearchResultsProps, SiteSearchResultModel } from './contracts';
import { SearchResult } from './styled';

export const RenderSearchResults = (props: IRenderSearchResultsProps) => {
	const { results } = props;
	const { font, fontColour, headerTextShadow, subtextFont, subtextFontColour } = useComponentStyleContext();
	const { headerSubtextClass } = useComponentClassContext();

	if (!results?.results) return <></>;

	return (
		<Stack width="100%" gap={2}>
			<Typography style={{ ...font }}>{`Total results: ${results.total}`}</Typography>
			{results?.results?.map((result: SiteSearchResultModel) => {
				return (
					<SearchResult key={result.id}>
						<a href={`${result.urlName}`} className="link-style">
							<Typography
								variant="h4"
								style={{ ...subtextFont, ...subtextFontColour, ...headerTextShadow }}
								className={headerSubtextClass}
							>
								{result.pageHeading}
							</Typography>
						</a>
						<Typography fontStyle="italic" color="text.secondary" style={{ ...fontColour }}>
							{result.createDate ? `Created on: ${result.createDate} ` : ''}
						</Typography>
						<Typography fontStyle="italic" color="text.secondary" style={{ ...fontColour }}>
							{result.updateDate ? `Last updated on: ${result.updateDate}` : ''}
						</Typography>
					</SearchResult>
				);
			})}
		</Stack>
	);
};
